<template>
  <v-container>
    <v-layout row>
      <v-flex xs10 md7 offset-md2 pb-3>
        <v-btn flat class="primary" router @click="back">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 pt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-flex xs12 md8 offset-md2>
      <v-card class="cardText cardBackground" v-if="loaded">
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs12>
              <div pb-3 class="headline">{{ name }} {{lastName}}</div>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex md6 offset-md1 mb-1>
            <div>
              <span class="userElement">Email:</span>
              {{email}}
            </div>
          </v-flex>
          <v-flex md6 offset-md1 mb-1>
            <div>
              <span class="userElement">Indirizzo:</span>
              {{address}}
            </div>
          </v-flex>
          <v-flex md6 offset-md1 mb-1>
            <div>
              <span class="userElement">Comune:</span>
              {{comune}}
            </div>
          </v-flex>
          <v-flex md6 offset-md1 mb-1>
            <div>
              <span class="userElement">Provincia:</span>
              {{province}}
            </div>
          </v-flex>
          <v-flex md6 offset-md1 mb-1>
            <div>
              <span class="userElement">Codice Fiscale:</span>
              {{cod}}
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import { bus } from "../main";
import { db } from "../main";
export default {
  data: () => ({
    loaded: false,
    userID: "",
    name: "",
    lastName: "",
    email: "",
    address: "",
    comune: "",
    province: "",
    cod: ""
  }),
  methods: {
    //metodo per far tornare l'utente alla pagina precedente
    back() {
      window.history.back();
    }
  },
  //metodo per il recupero delle info riguardati l'utente selezionato
  created() {
    var user = this.$store.getters.getSelectedUser;
    this.userID = user;
    db.collection("utenti")
      .doc(this.userID)
      .get()
      .then(doc => {
        this.name = doc.data().nome;
        this.lastName = doc.data().cognome;
        this.email = doc.data().email;
        this.address = doc.data().indirizzo;
        this.comune = doc.data().comune;
        this.province = doc.data().provincia;
        this.cod = doc.data().codice_fiscale;
      })
      .then(() => {
        this.loaded = true;
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore: problema nel caricamento dei dati dell'utente(" + error + ")"
        );
      });
  }
};
</script>

